<mat-list-item [class.active]="selected">
  <div
    class="section-like"
    id="wsr-references"
    (click)="navigateToWsrReferences()"
    (keyup.enter)="navigateToWsrReferences()"
    (keyup.Space)="navigateToWsrReferences()"
    aria-label="View WSR references"
    tabindex="0"
  >
    <div class="section-details">
      <div
        class="left-hand-buffer"
        *ngIf="CarsAction.AUTHOR_DOCUMENT | carsEnabled : document.documentId | async"
      ></div>
      <span id="section-index" matPrefix>
        {{ sectionIndex }}
      </span>
      <span id="section-title">
        {{ sectionTitle }}
      </span>
    </div>
  </div>

  <cars-alt-accessibility
    class="wsr-references"
    [altProperties]="{initialKey: 'q', key: 'c', condition: true}"
    (onSelect)="focusOverview()"
  ></cars-alt-accessibility>
</mat-list-item>
